export const dronesData = {
  hero: {
    title: 'Tecnología Drónica en Investigación Ambiental',
    subtitle: 'Vigilancia Aérea Inteligente para Análisis de Ecosistemas',
    description: 'El uso de drones para la recopilación de datos en terrenos extensos o de difícil acceso. Esta tecnología permite realizar inspecciones rápidas y detalladas, facilitando la detección temprana de problemas ambientales.',
    image: '/img/proyectos/drones/dron-modelo3D.webp',
    cta: 'Explorar Capacidades Técnicas',
    stats: [
      { value: '85%', label: 'Reducción tiempo de inspección' },
      { value: '2-5cm', label: 'Resolución espacial' },
      { value: '100+ Ha', label: 'Cobertura diaria' }
    ]
  },

  capabilities: [
    {
      id: 1,
      title: 'Fotogrametría 3D de Alta Precisión',
      description: 'Generación de modelos digitales de terreno (MDT) y superficies (MDS) con precisión centimétrica para análisis topográfico.',
      icon: '📐',
      applications: ['Cartografía detallada', 'Cálculo de volúmenes', 'Monitorización de erosión'],
      metrics: { precision: '±3 cm', resolution: '2 cm/píxel', coverage: '50 Ha/día' }
    },
    {
      id: 2,
      title: 'Teledetección Multiespectral',
      description: 'Captura de datos en múltiples bandas espectrales para análisis de salud vegetal mediante índices NDVI, NDRE y otros.',
      icon: '🌿',
      applications: ['Salud de cultivos', 'Detección de estrés hídrico', 'Monitoreo forestal'],
      metrics: { bands: '5 bandas espectrales', ndvi: 'Resolución 0.01', frequency: 'Semanal' }
    },
    {
      id: 3,
      title: 'Termografía Aérea',
      description: 'Detección de variaciones térmicas para identificar fugas, monitorizar actividades industriales y estudiar microclimas.',
      icon: '🔥',
      applications: ['Detección de fugas', 'Estudios microclimáticos', 'Monitorización industrial'],
      metrics: { sensitivity: '0.1°C', range: '-20°C a 550°C', resolution: '640x512 px' }
    },
    {
      id: 4,
      title: 'Sistemas LIDAR',
      description: 'Tecnología láser para modelado de terreno bajo cubierta vegetal densa y creación de nubes de puntos 3D.',
      icon: '🗺️',
      applications: ['Modelado bajo vegetación', 'Inventario forestal', 'Planificación urbana'],
      metrics: { accuracy: '±5 cm', density: '200 pts/m²', penetration: 'Múltiples retornos' }
    }
  ],

  workflow: {
    title: 'Flujo de Trabajo Científico',
    steps: [
      {
        step: 1,
        title: 'Planificación de Vuelo',
        description: 'Diseño de rutas optimizadas considerando objetivos científicos, condiciones meteorológicas y regulaciones.',
        tools: ['Software de planificación', 'Análisis METAR', 'Optimización de rutas']
      },
      {
        step: 2,
        title: 'Adquisición de Datos',
        description: 'Captura sistemática de imágenes, datos espectrales y térmicos con calibración in-situ.',
        tools: ['Drones especializados', 'Sensores calibrados', 'Estaciones terrestres']
      },
      {
        step: 3,
        title: 'Procesamiento Avanzado',
        description: 'Generación de ortomosaicos, modelos 3D y análisis espectral mediante pipelines automatizados.',
        tools: ['Fotogrametría (Pix4D, Agisoft)', 'Análisis GIS', 'Machine Learning']
      },
      {
        step: 4,
        title: 'Análisis e Interpretación',
        description: 'Extracción de métricas científicas, identificación de patrones y generación de reportes.',
        tools: ['Estadística espacial', 'Deep Learning', 'Visualización 3D']
      }
    ]
  },

  caseStudies: [
    {
      title: 'Monitorización de Humedales',
      location: 'Delta del Ebro, España',
      challenge: 'Evaluación del impacto del cambio climático en ecosistemas acuáticos',
      solution: 'Uso de drones multiespectrales para análisis de vegetación acuática y calidad del agua',
      results: ['Mapa de especies invasoras', 'Detección de eutrofización', 'Modelo predictivo de cambios'],
      image: '/img/proyectos/drones/caso-humedales.webp'
    },
    {
      title: 'Inspección de Infraestructuras',
      location: 'Parque Eólico Marítimo',
      challenge: 'Mantenimiento preventivo de turbinas en ubicaciones de difícil acceso',
      solution: 'Drones con cámaras térmicas y de alta resolución para inspección detallada',
      results: ['Reducción 80% costes inspección', 'Detección temprana de fallos', 'Documentación 3D completa'],
      image: '/img/proyectos/drones/caso-eolicas.webp'
    }
  ],

  technicalSpecs: {
    sensors: [
      { name: 'Cámara RGB', resolution: '20 MP', rate: '1 foto/segundo' },
      { name: 'Multiespectral', bands: '5 (R,G,B,Red Edge,NIR)', resolution: '2.4 MP' },
      { name: 'Térmica', resolution: '640x512', sensitivity: '<50 mK' },
      { name: 'LIDAR', accuracy: '±3 cm', range: '450 m' }
    ],
    platforms: [
      { type: 'Ala Fija', endurance: '120 min', range: '50 km', payload: '1 kg' },
      { type: 'Multirrotor', endurance: '40 min', precision: '±1 cm', payload: '2 kg' }
    ]
  }
};